// Centralní konfigurace reklamních slotů.
// Změna providera / slotu / frekvence se dělá tady, ne ve stránkách.

export const ADSENSE_CLIENT = "ca-pub-5302314024140848";

export type AdProvider = "adsense" | "house" | "auto";
export type AdFormat = "in-feed" | "in-article" | "display" | "house";

export interface AdPlacement {
  /** Provider preference. "auto" = AdSense pokud načteno, jinak house. */
  provider: AdProvider;
  format: AdFormat;
  /** AdSense data-ad-slot */
  slot?: string;
  /** Max počet této placement na jednu stránku (per session loadu). */
  maxPerPage?: number;
  /** Minimální výška kontejneru kvůli CLS (px) */
  minHeight: number;
  /** Pro in-feed layout (AdSense) */
  layoutKey?: string;
}

export const AD_PLACEMENTS = {
  "landing-inline": {
    provider: "auto",
    format: "in-article",
    slot: "1421118798",
    maxPerPage: 2,
    minHeight: 250,
  },
  "dashboard-feed": {
    provider: "auto",
    format: "in-feed",
    slot: "9528663354",
    layoutKey: "-6t+ed+2i-1n-4w",
    maxPerPage: 2,
    minHeight: 180,
  },
  "matches-feed": {
    provider: "auto",
    format: "in-feed",
    slot: "5589418349",
    layoutKey: "-6t+ed+2i-1n-4w",
    maxPerPage: 2,
    minHeight: 180,
  },
  "standings-bottom": {
    provider: "auto",
    format: "display",
    slot: "8024009993",
    maxPerPage: 1,
    minHeight: 280,
  },
  "league-inline": {
    provider: "auto",
    format: "in-article",
    slot: "4949300260",
    maxPerPage: 1,
    minHeight: 250,
  },
  "invite-bottom": {
    provider: "house",
    format: "house",
    maxPerPage: 1,
    minHeight: 200,
  },
} satisfies Record<string, AdPlacement>;

export type PlacementId = keyof typeof AD_PLACEMENTS;

// House / affiliate creatives — rotace.
// Affiliate linky (Fortuna/Tipsport/Betano) doplníte sem až budete mít accounty.
export interface HouseCreative {
  id: string;
  kind: "affiliate" | "house";
  title: string;
  body: string;
  cta: string;
  href: string;
  external?: boolean;
  /** Volitelný badge "Sponzorováno" */
  sponsored?: boolean;
}

export const HOUSE_CREATIVES: HouseCreative[] = [
  {
    id: "invite-friends",
    kind: "house",
    title: "Pozvi kamarády do své ligy",
    body: "Čím víc tipujících, tím větší zábava. Sdílej pozvánku a hraj společně.",
    cta: "Vytvořit ligu",
    href: "/",
  },
  {
    id: "premium-league",
    kind: "house",
    title: "Premium liga s dalšími pravidly",
    body: "Vlastní logo, neomezený počet hráčů, soukromé ligy pro členy.",
    cta: "Zjistit víc",
    href: "/help",
  },
  // --- AFFILIATE PLACEHOLDERS (doplňte vlastní tracking linky) ---
  // {
  //   id: "fortuna-ms2026",
  //   kind: "affiliate",
  //   title: "Vsaď si na MS s Fortunou",
  //   body: "Bonus 1 000 Kč pro nové hráče. 18+, hraj zodpovědně.",
  //   cta: "Získat bonus",
  //   href: "https://www.ifortuna.cz/?affid=YOUR_ID",
  //   external: true,
  //   sponsored: true,
  // },
];
